(function () {
  const loadSlides = async (slider, params) => {
    const lazyloader = slider.querySelector('.cg-slider__lazyloader');

    try {
      const response = await fetch(load_more_data.url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: new URLSearchParams(params),
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const responseText = await response.text();
      lazyloader.outerHTML = responseText;

      if (params.source === 'toplist') {
        const loadMoreEvent = new CustomEvent('loadMoreTriggered', {
          detail: {
            type: 'toplist',
          }
        });

        document.dispatchEvent(loadMoreEvent);
      }
    } catch (error) {
      console.error('Error:', error);
    }
  };

  const getSliderParams = (sliderType) => {
    const sliderConfigs = {
      default: (lazyloader) => ({
        nonce: load_more_data.nonce,
        locale: load_more_data.locale,
        page: "1",
        source: "toplist",
        perPage: lazyloader.getAttribute('data-per-page'),
        showAll: "1",
        toplistId: lazyloader.getAttribute('data-toplist-id'),
        dbBrands: "",
        params: "{\"layout\":\"slider\"}",
        action: 'more_brands'
      }),
      custom: (lazyloader) => ({
        nonce: load_more_data.nonce,
        locale: load_more_data.locale,
        postType: lazyloader.getAttribute('data-post-type'),
        targetPagePostId: lazyloader.getAttribute('data-id'),
        perPage: lazyloader.getAttribute('data-per-page'),
        action: 'more_slider_items'
      }),
    };

    return sliderConfigs[sliderType] || sliderConfigs.default;
  };

  document.addEventListener('DOMContentLoaded', () => {
    const sliders = document.querySelectorAll('.cg-slider');

    sliders.forEach((slider) => {
      const slideForward = () => {
        const cardWidth = slider.querySelector('.cg-slider__items > *').offsetWidth;
        slider.scrollBy(Math.abs(window.innerWidth - 2 * cardWidth), 0);
      };

      const slideBackward = () => {
        const cardWidth = slider.querySelector('.cg-slider__items > *').offsetWidth;
        slider.scrollBy(-window.innerWidth + 2 * cardWidth, 0);
      };

      slider.querySelector('.cg-slider__prev').addEventListener('click', slideBackward);
      slider.querySelector('.cg-slider__next').addEventListener('click', slideForward);

      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach(entry => {
            if (entry.target.className.includes('start')) {
              slider.classList.toggle('cg-slider--start', entry.isIntersecting);
            }
            if (entry.target.className.includes('end')) {
              slider.classList.toggle('cg-slider--end', entry.isIntersecting);
            }
            if (entry.target.className.includes('cg-slider__lazyloader') && entry.isIntersecting) {
              const sliderType = slider.getAttribute('data-slider-type') ?? 'default';
              const paramsGetter = getSliderParams(sliderType);

              loadSlides(slider, paramsGetter(entry.target)).then(slideForward);
            }
          });
        },
        { root: slider }
      );

      const observed = slider.querySelectorAll('.cg-slider__start-gutter, .cg-slider__end-gutter, .cg-slider__lazyloader');
      observed.forEach(el => observer.observe(el));
    });
  });
})();
